<template>
  <v-btn class="normal-btn-text elevation-0 rounded-tag-small ml-2"
         :color="color"
         :loading="loadingPdf"
         @click="gerarPdf">
    <v-icon>mdi-file-pdf-box</v-icon>
    Gerar PDF
  </v-btn>
</template>

<script>
import { TipoRelatorio } from 'px-business-components';
import FinalizacaoService from './finalizacao-service';

export default {
  props: {
    compraId: String,
    compra: Object,
    color: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loadingPdf: false,
    };
  },
  methods: {
    gerarPdf() {
      this.loadingPdf = true;
      const payload = {
        tipoRelatorio: TipoRelatorio.keys.ORDEM_COMPRA_FORNECEDOR.key,
        arguments: {
          idCompra: this.compra.id,
        },
      };
      return FinalizacaoService.generatePdf(this.compraId, this.compra.comprador.id, payload)
        .then(({ data }) => {
          window.open(data.reportUrl);
        })
        .finally(() => {
          this.loadingPdf = false;
        });
    },
  },
};
</script>
